<form [formGroup]="form" class="style-form-default">
  <div
    class="style-input-default"
    data-text="N° de denuncia *"
    [ngClass]="{ error: verificateInput('numero_denuncia') }"
  >
    <input
      type="text"
      placeholder="N° de denuncia"
      formControlName="numero_denuncia"
      onlyNumber
    />
  </div>
  <div
    class="style-input-default"
    data-text="Fecha de la denuncia *"
    [ngClass]="{ error: verificateInput('fecha_denuncia') }"
  >
    <input type="date" formControlName="fecha_denuncia" />
  </div>
</form>
